import React from 'react';

const AboutMe = () => {
    return (
        <div className="container mx-auto mt-8 px-4 sm:px-6 lg:px-8">

            <div className="bg-principal py-10 rounded-xl shadow-lg transition-all duration-300 ease-out hover:shadow-2xl">

                <div className='flex flex-col sm:flex-row items-center justify-center space-y-10 sm:space-y-0 sm:space-x-10'>

                    <div className=' w-52 h-52 rounded-full overflow-hidden border-4 cursor-pointer bg-principal text-principal border-white hover:bg-white hover:text-white hover:scale-95 transition-all duration-200 ease-out'>
                        <img src={`${process.env.PUBLIC_URL}/mamá2.png`} alt='Avatar' className='w-full h-full object-cover object-bottom' />
                    </div>

                    <h1 className=" text-6xl font-ubuntu text-white text-center">
                        Alba Luz Ramos
                    </h1>

                </div>

            </div>

            <div className='pt-12 text-black text-3xl font-ubuntu'>
                <div className='flex flex-col sm:flex-row justify-between'>
                    <div className='sm:w-1/3 text-center'>
                        <h2 className='font-semibold pb-5 text-principal'>
                            Experiencia Laboral
                        </h2>

                        <p className='text-2xl font-mukta'>
                            28 años - <em>Secretaria</em> - Notaria 1ra de Pitalito
                        </p>

                    </div>

                    <div className='sm:w-1/3 text-center'>
                        <h2 className='font-semibold pb-5 text-principal'>
                            Conocimientos
                        </h2>

                        <p className='text-2xl font-mukta'>
                            Notariales
                        </p>
                    </div>

                    <div className='sm:w-1/3 text-center'>
                        <h2 className='font-semibold pb-5 text-principal'>
                            Horario de Trabajo
                        </h2>

                        <p className='text-2xl font-mukta font-bold text-principal underline'>
                            Lunes a Viernes
                        </p>

                        <p className='text-2xl font-mukta'>
                            8:30 am - 12:30pm
                        </p>
                        <p className='text-2xl font-mukta'>
                            2:30pm - 6:30pm
                        </p>
                    </div>
                </div>
            </div>
        </div>

        
    )
}

export default AboutMe;